// components/tabs/BrowseTab.js
import React, { useEffect, useState } from 'react';
import { API_URL, ENDPOINTS } from '../../../constants/api';
import { getToken } from '../../../utils/TokenUtils';
import axios from 'axios';
import '../css/BrowseTab.css';

function BrowseTab({ table }) {
  const [rows, setRows] = useState([]);
  const token = getToken();
  useEffect(() => {
    const browse = async () => {
      const response = await axios.get(
        `${API_URL}/${ENDPOINTS.SQL}/browse/${table}`,
        {
          headers: { Authorization: token ? `Bearer ${token}` : '' },
        }
      );

      setRows(response.data);
    };
    browse();
  }, [table]);

  if (!rows.length) return <p>No data available.</p>;

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped table-hover">
        <thead className="table-dark">
          <tr>
            {Object.keys(rows[0]).map((col, i) => (
              <th key={i}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {Object.values(row).map((val, j) => (
                <td key={j}>{val}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BrowseTab;
